var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.148438V2.5H14V0.148438H7ZM18.7031 7.64062C19.4323 8.51562 19.9974 9.51823 20.3984 10.6484C20.7995 11.7422 21 12.9089 21 14.1484C21 15.6068 20.7266 16.974 20.1797 18.25C19.6328 19.526 18.8672 20.638 17.8828 21.5859C16.9349 22.5339 15.8229 23.2812 14.5469 23.8281C13.3073 24.375 11.9583 24.6484 10.5 24.6484C9.04167 24.6484 7.67448 24.375 6.39844 23.8281C5.15885 23.2812 4.04688 22.5339 3.0625 21.5859C2.11458 20.638 1.36719 19.526 0.820312 18.25C0.273438 16.974 0 15.6068 0 14.1484C0 12.7266 0.273438 11.3776 0.820312 10.1016C1.36719 8.82552 2.11458 7.71354 3.0625 6.76562C4.04688 5.78125 5.15885 5.01562 6.39844 4.46875C7.67448 3.92188 9.04167 3.64844 10.5 3.64844C11.7396 3.64844 12.9062 3.86719 14 4.30469C15.1302 4.70573 16.151 5.27083 17.0625 6L18.7031 4.30469C18.9948 4.5599 19.2682 4.83333 19.5234 5.125C19.8151 5.38021 20.0885 5.65365 20.3438 5.94531L18.7031 7.64062ZM11.6484 15.3516V8.35156H9.35156V15.3516H11.6484Z",
    fill: "#00A377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer_icon.1f6426a70aaa8f04dc614d83a8e3ba36.svg";
export { ForwardRef as ReactComponent };